import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import GetAppRoundedIcon from "@mui/icons-material/GetAppRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import NavigateBeforeRoundedIcon from "@mui/icons-material/NavigateBeforeRounded";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SyncAltRoundedIcon from "@mui/icons-material/SyncAltRounded";
import { debounce } from "lodash";
import { forwardRef, useCallback, useEffect, useRef, useState } from "react";
// import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import BasicButton from "../../components/common/button/BasicButton";
import CustomDialog from "../../components/common/dialog/CustomDialog";
import { GetAssetLazy } from "../../redux/actions/AssetsManagement/Assets";
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import {
  Checkbox,
  CircularProgress,
  Divider,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import { Box } from "@mui/system";
import ExportDropdown from "./ExportDropdown";

export const tableIcons: any = {
  Search: forwardRef((props, ref) => <SearchRoundedIcon />),
  DetailPanel: forwardRef((props, ref) => <ChevronRightIcon />),
  Clear: forwardRef((props, ref) => <CloseRoundedIcon />),
  ResetSearch: forwardRef((props, ref) => <CloseRoundedIcon />),
  ViewColumn: forwardRef((props, ref) => <ViewColumnIcon />),
  SortArrow: forwardRef((props, ref) => (
    <SyncAltRoundedIcon
      sx={{ color: "gray", transform: "rotate(90deg)", width: "15px" }}
    />
  )),
  Export: forwardRef((props, ref) => <GetAppRoundedIcon />),
  Filter: forwardRef((props, ref) => (
    <FilterListRoundedIcon sx={{ width: "20px" }} />
  )),
  FirstPage: forwardRef((props, ref) => (
    <FirstPageRoundedIcon sx={{ width: "20px" }} />
  )),
  LastPage: forwardRef((props, ref) => (
    <LastPageRoundedIcon sx={{ width: "20px" }} />
  )),
  NextPage: forwardRef((props, ref) => (
    <NavigateNextRoundedIcon sx={{ width: "20px" }} />
  )),
  PreviousPage: forwardRef((props, ref) => (
    <NavigateBeforeRoundedIcon sx={{ width: "20px" }} />
  )),
};

function TextWithTooltip({ text, width = 120 }: any) {
  const displayText = text?.length > 20 ? text.slice(0, 20) + "..." : text;

  return (
    <Tooltip
      title={text || ""}
      enterTouchDelay={0}
      arrow
    >
      <span
        tabIndex={0} // make focusable so tooltip also triggers on keyboard focus
        style={{
          display: 'inline-block',
          maxWidth: width,
          minWidth: 120,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          cursor: 'default',
          pointerEvents: 'auto', // ensure mouse events work
        }}
      >
        {displayText}
      </span>
    </Tooltip>
  );
}


const TableHeader = ({
  filterValRef,
  onFilterChange,
  defaultContactFilter,
  setdefaultContactFilter,
  isLoading
}: {
  filterValRef: React.MutableRefObject<Record<string, string | null>>;
  onFilterChange: () => void;
  defaultContactFilter: string;
  setdefaultContactFilter: any;
  isLoading: boolean;
}) => {
  const [nameValue, setNameValue] = useState('');
  const [contactValue, setContactValue] = useState(defaultContactFilter);
  const [typeValue, setTypeValue] = useState('');
  const [departmentValue, setDepartmentValue] = useState('');
  const [tagValue, setTagValue] = useState('');

  const handleChange = (key: string, value: string, setStateFn?: React.Dispatch<React.SetStateAction<string>>) => {
    if (setStateFn) {
      setStateFn(value);
    }
    filterValRef.current[key] = value || null;
    onFilterChange();
  };

  const clearSearch = (key: string, setStateFn?: React.Dispatch<React.SetStateAction<string>>) => {
    if (setStateFn) {
      setStateFn('');
    }
    filterValRef.current[key] = null;
    onFilterChange();
  };

  return (
    <TableHead   sx={{ '& .MuiTableCell-root': { padding: 1 } }}>
      <TableRow sx={{backgroundColor:'rgb(234, 242, 253)', m:0,p:0}} >
        <TableCell padding="checkbox"  />
        {['Asset Name', 'Contacts', 'Asset Type', 'Department', 'Asset Tags'].map((label) => (
          <TableCell sx={{fontSize:'16px'}}  key={label}>{label}</TableCell>
        ))}
      </TableRow>

      {/* Filter Row */}
      <TableRow >
        <TableCell 
        sx={{width:'50px', m:0}}
         />
        <TableCell>{renderTextField(nameValue, 'name','Name', setNameValue)}</TableCell>
        <TableCell>
          {renderTextField(
            contactValue,
            'contacts.name',
            "Contacts",
            setContactValue,
            setdefaultContactFilter
          )}
        </TableCell>
        <TableCell>{renderTextField(typeValue, 'assetType.name',"Asset Type", setTypeValue)}</TableCell>
        <TableCell >{renderTextField(departmentValue, 'contacts.department',"Department", setDepartmentValue)}</TableCell>
        <TableCell  >{renderTextField(tagValue, 'assetTag','Asset Tags', setTagValue)}</TableCell>
      </TableRow>
    </TableHead>
  );

  function renderTextField(
    value: string,
    key: string,
    placeHolder:string,
    setter: React.Dispatch<React.SetStateAction<string>>,
    optionalSetter?: React.Dispatch<any>
  ) {
    return (
<TextField
  variant="standard"
  value={value}
  onChange={(e) => {
    handleChange(key, e.target.value, setter);
    if (optionalSetter) optionalSetter(e.target.value);
  }}
  placeholder={`Search ${placeHolder}`}
  disabled={isLoading}
  InputProps={{
    disableUnderline: true,
          sx: { fontSize: 13, px: 1, border: '1px solid black' },
    endAdornment: (
      <InputAdornment position="end" sx={{ width: 32, display: 'flex', justifyContent: 'center' }}>
        {value ? (
          <IconButton onClick={() => clearSearch(key, setter)} size="small" sx={{ padding: '4px' }}>
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        ) : (
          // empty box to reserve space when icon hidden
          <span style={{ width: 24, display: 'inline-block' }} />
        )}
      </InputAdornment>
    ),
  }}
/>
    );
  }
};

const AddAssetComponent = ({
  setIsOpenAsset,
  isOpenAsset,
  selected,
  onAssetSelected,
  defaultContact,
  ticketId,
}: any) => {
  const dispatch = useDispatch();
  const [selectedAssets, setSelectedAssets] = useState<any[]>(selected || []);
  const [assetList, setAssetList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultContactFilter, setdefaultContactFilter] = useState(defaultContact || '');

  const filterVal = useRef<Record<string, string | null>>({
    name: null,
    'contacts.name': defaultContact || '',
    'assetType.name': null,
    'contacts.department': null,
    assetTag: null,
  });

  const getAssetCB = (
    pageNum: number,
    res: any,
    _: any,
    totalCount: number
  ) => {
    setIsLoading(false);
    setTotalCount(totalCount);
    setAssetList(res?.assets || []);
  };

  //  Regular fetch (for pagination and rowsPerPage)
  const fetchAssets = useCallback((
    pageNum: number = 0
  ) => {
    const f = filterVal.current;
    setIsLoading(true);
    dispatch(
      GetAssetLazy(
        pageNum,
        true,
        null,
        getAssetCB,
        rowsPerPage,
        f.name,
        f["contacts.name"],
        f["assetType.name"],
        f["contacts.department"],
        f.assetTag
      )
    );
  }, [rowsPerPage]);

  //  Debounced fetch on filters
  const debouncedFilterFetch = useRef(
    debounce(() => {
      fetchAssets(0);
    }, 1300)
  );

  const handleFilterChange = useCallback(() => {
    debouncedFilterFetch.current();
  }, []);

  useEffect(() => {
    fetchAssets(0);
    return () => {
      debouncedFilterFetch.current.cancel();
    };
  }, [fetchAssets]);

  //  Handle pagination change
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
    fetchAssets(newPage);
  };

  // Handle page size change
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
    fetchAssets(0);
  };

  const isSelected = (id: number) =>
    selectedAssets.some(a => a.assetId === id || a.asset?.id === id);

  const handleClick = (event: React.MouseEvent<unknown>, row: any) => {
    const exists = isSelected(row.id);
    const updated = exists
      ? selectedAssets.filter(a => a.assetId !== row.id && a.asset?.id !== row.id)
      : [
          ...selectedAssets,
          {
            assetId: row.id,
            isActive: true,
            createdDateTime: new Date().toISOString(),
            updatedDateTime: new Date().toISOString(),
            asset: {
              id: row.id,
              name: row.name,
              assetTag: row.assetTag || '',
              assetType: row.assetType || null,
            },
          },
        ];
    setSelectedAssets(updated);
  };

  return (
    <CustomDialog 
      heading={
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Add Asset</Typography>
            <ExportDropdown data={assetList} onlyCsv />
          </Box>
          <Divider />
          <Table size="small">
            <TableHeader
              filterValRef={filterVal}
              onFilterChange={handleFilterChange}
              defaultContactFilter={defaultContactFilter}
              setdefaultContactFilter={setdefaultContactFilter}
              isLoading={isLoading}
            />
          </Table>
        </>
      }
      open={isOpenAsset}
      handleClose={() => setIsOpenAsset(false)}
      body={
        <Paper >
          <TableContainer sx={{minHeight:'80vh'}} >
            {isLoading ? (
              <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress />
              </Box>
            ) : (
              <Table stickyHeader size="small" >
                <TableBody >
                  {assetList.map((row) => {
                    const isItemSelected = isSelected(row.id);
                    return (
                      <TableRow
                        key={row.id}
                        hover
                        selected={isItemSelected}
                        onClick={e => handleClick(e, row)}
                      >
                        <TableCell  padding="checkbox">
                          <Checkbox checked={isItemSelected} />
                        </TableCell>
                        <TableCell sx={{fontSize:'16px', maxWidth:'300px'}}><TextWithTooltip  text={row.name} /></TableCell>
                        <TableCell sx={{fontSize:'16px'}}><TextWithTooltip  text={row.contacts?.name || '-'} /></TableCell>
                        <TableCell sx={{fontSize:'16px'}}><TextWithTooltip  text={row.assetType?.name || '-'} /></TableCell>
                        <TableCell sx={{fontSize:'16px'}}><TextWithTooltip text={row.contacts?.department?.name || '--'} /></TableCell>
                        <TableCell sx={{fontSize:'16px'}}><TextWithTooltip text={row.assetTag || '-'} /></TableCell>
                      </TableRow>
                    );
                  })}
                  {assetList.length === 0 && !isLoading && (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Typography>No assets found.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </Paper>
      }
      footer={
        <Box display="flex" gap={2}>
          <TablePagination
          sx={{fontSize: '16px', }}
            component="div"
            count={totalCount}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <BasicButton
            onClick={() => setIsOpenAsset(false)}
            label="Cancel"
            variant="outlined"
            color="primary"
            endIcon={<CloseIcon />}
          />
          <BasicButton
            onClick={() => {
              onAssetSelected(selectedAssets);
              setIsOpenAsset(false);
            }}
            label={`${selectedAssets.length} Select Asset(s)`}
            color="primary"
            variant="contained"
            endIcon={<AddRoundedIcon />}
          />
        </Box>
      }
    />
  );
};

export default AddAssetComponent;